import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { PortisConnector } from '@web3-react/portis-connector'

import { FortmaticConnector } from './Fortmatic'
import { NetworkConnector } from './NetworkConnector'

const NETWORK_URL = process.env.REACT_APP_NETWORK_URL
const FORMATIC_KEY = process.env.REACT_APP_FORTMATIC_KEY
const PORTIS_ID = process.env.REACT_APP_PORTIS_ID

if (typeof NETWORK_URL === 'undefined') {
  throw new Error(`REACT_APP_NETWORK_URL must be a defined environment variable`)
}

export const network = new NetworkConnector({
  urls: { [Number(process.env.REACT_APP_CHAIN_ID)]: NETWORK_URL }
})

export const injected = new InjectedConnector({
  supportedChainIds: [Number(process.env.REACT_APP_CHAIN_ID)]
})

// mainnet only
export const walletconnect = new WalletConnectConnector({
  rpc: { [Number(process.env.REACT_APP_CHAIN_ID)]: NETWORK_URL },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: 15000
})

// mainnet only
const FM_SUPPORTED = [1, 3, 4, 42].includes(Number(process.env.REACT_APP_CHAIN_ID))
export const fortmatic: any = FM_SUPPORTED
  ? new FortmaticConnector({
      apiKey: FORMATIC_KEY ?? '',
      chainId: Number(process.env.REACT_APP_CHAIN_ID)
    })
  : undefined

// mainnet only
const PORTIS_SUPPORTED = [1, 3, 4, 42].includes(Number(process.env.REACT_APP_CHAIN_ID))
export const portis: any = PORTIS_SUPPORTED
  ? new PortisConnector({
      dAppId: PORTIS_ID ?? '',
      networks: [Number(process.env.REACT_APP_CHAIN_ID)]
    })
  : undefined

// mainnet only
export const walletlink = new WalletLinkConnector({
  url: NETWORK_URL,
  appName: 'Uniswap',
  appLogoUrl:
    'https://mpng.pngfly.com/20181202/bex/kisspng-emoji-domain-unicorn-pin-badges-sticker-unicorn-tumblr-emoji-unicorn-iphoneemoji-5c046729264a77.5671679315437924251569.jpg'
})
